/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ScheduledTransferLineItem,
  ScheduledTransferLineItem$inboundSchema,
  ScheduledTransferLineItem$Outbound,
  ScheduledTransferLineItem$outboundSchema,
} from "./scheduledtransferlineitem.js";

/**
 * Line items for a scheduled transfer.
 */
export type ScheduledTransferLineItems = {
  /**
   * The list of line items.
   */
  items: Array<ScheduledTransferLineItem>;
};

/** @internal */
export const ScheduledTransferLineItems$inboundSchema: z.ZodType<
  ScheduledTransferLineItems,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(ScheduledTransferLineItem$inboundSchema),
});
/** @internal */
export type ScheduledTransferLineItems$Outbound = {
  items: Array<ScheduledTransferLineItem$Outbound>;
};

/** @internal */
export const ScheduledTransferLineItems$outboundSchema: z.ZodType<
  ScheduledTransferLineItems$Outbound,
  z.ZodTypeDef,
  ScheduledTransferLineItems
> = z.object({
  items: z.array(ScheduledTransferLineItem$outboundSchema),
});

export function scheduledTransferLineItemsToJSON(
  scheduledTransferLineItems: ScheduledTransferLineItems,
): string {
  return JSON.stringify(
    ScheduledTransferLineItems$outboundSchema.parse(scheduledTransferLineItems),
  );
}
export function scheduledTransferLineItemsFromJSON(
  jsonString: string,
): SafeParseResult<ScheduledTransferLineItems, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ScheduledTransferLineItems$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ScheduledTransferLineItems' from JSON`,
  );
}
